import { ActivityGridBaseDataProvider } from './ActivityGridBaseDataProvider';
import { ViewType } from '../../../grid/gridView/types';
import { ColumnDetails, ColumnType } from '../../../grid/types/common';
import { STATUS, Column, ColumnKeys, ActivityGridViewData } from '../types';

export class ActivityGridGzDataProvider extends ActivityGridBaseDataProvider {
  private FILTERS = [{ status: { in: [STATUS.PENDING, STATUS.IN_PROGRESS, STATUS.FINISHED, STATUS.FAILED] } }];

  private getGridColumn(): Array<ColumnDetails<Column, ColumnKeys>> {
    return [
      {
        column: Column.FILE_NAME,
        key: ColumnKeys.FILE_NAME,
        columnName: this.dependencies.translateFn('Investigation file name'),
        type: ColumnType.STRING,
        removable: false,
      },
      {
        column: Column.ACTIVITY,
        key: ColumnKeys.ACTIVITY,
        columnName: this.dependencies.translateFn('Activity Name'),
        type: ColumnType.STRING,
        removable: false,
      },
      {
        column: Column.STARTED_ON,
        key: ColumnKeys.STARTED_ON,
        columnName: this.dependencies.translateFn('Started on'),
        type: ColumnType.DATE,
        removable: true,
      },
      {
        column: Column.FINISHED_ON,
        key: ColumnKeys.FINISHED_ON,
        columnName: this.dependencies.translateFn('Finished on'),
        type: ColumnType.DATE,
        removable: true,
      },
      {
        column: Column.FILE_EXPIRES_ON,
        key: ColumnKeys.FILE_EXPIRES_ON,
        columnName: this.dependencies.translateFn('File expires on'),
        type: ColumnType.DATE,
        removable: true,
      },
      {
        column: Column.STATUS,
        key: ColumnKeys.STATUS,
        columnName: this.dependencies.translateFn('Status'),
        type: ColumnType.ENUM,
        values: [
          {
            label: this.dependencies.translateFn('Pending'),
            value: STATUS.PENDING,
          },
          {
            label: this.dependencies.translateFn('In Progress'),
            value: STATUS.IN_PROGRESS,
          },
          {
            label: this.dependencies.translateFn('Failed'),
            value: STATUS.FAILED,
          },
          {
            label: this.dependencies.translateFn('Finished'),
            value: STATUS.FINISHED,
          },
          {
            label: this.dependencies.translateFn('File available'),
            value: STATUS.TO_BE_RETRIEVED,
          },
        ],
        removable: false,
      },
      {
        column: Column.ACTION,
        key: ColumnKeys.ACTION,
        columnName: this.dependencies.translateFn('Action'),
        type: ColumnType.STRING,
        removable: true,
      },
    ];
  }

  public async getDataForView(): Promise<ActivityGridViewData> {
    const view = {
      id: 'activity-item-grid',
      name: 'Default view',
      type: ViewType.DEFAULT,
      filters: this.FILTERS,
      displayedColumns: [0, 1, 2, 3, 4, 5, 6],
      pageSize: 50,
      selectedTargets: [],
    };
    return {
      targets: [],
      isPartner: false,
      views: [view],
      allColumns: this.getGridColumn(),
      defaultViewProps: view,
    };
  }
}
